import React from "react"
import PropTypes from "prop-types"
import { Row, Col, Card, CardBody } from "reactstrap"

const MiniCards = ({
  reports = [],
  mode = "light",
  cardPadding = "40px 24px",
  onCardClick,
}) => {
  // 🔹 Dynamically determine column size based on number of reports
  const getColSize = (count) => {
    switch (count) {
      case 1:
        return 12
      case 2:
        return 6
      case 3:
        return 4
      default:
        return 3 // 4 or more → 4 columns
    }
  }

  const colSize = getColSize(reports.length)

  return (
    <Row>
      {reports.map((report, index) => (
        <Col
          key={index}
          xl={colSize}
          lg={colSize}
          md={6}
          sm={12}
        >
          <Card
            onClick={() => onCardClick?.(report)}
            style={{
              cursor: onCardClick ? "pointer" : "default",
              border: "none",
              borderRadius: "16px",
              backgroundColor: mode === "dark" ? "#252f40" : "#fff",
              boxShadow:
                mode === "dark"
                  ? "0px 2px 6px rgba(0,0,0,0.5)"
                  : "0px 2px 6px rgba(0,0,0,0.1)",
              transition: "all 0.3s ease",
            }}
          >
            <CardBody
              className="d-flex align-items-center justify-content-between"
              style={{ padding: cardPadding }}
            >
              {/* Left Side */}
              <div>
                <h6
                  style={{
                    color: mode === "dark" ? "#9CA3AF" : "#6B7280",
                    marginBottom: "4px",
                    fontSize: "14px",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  {report.title}
                </h6>
                <h4
                  style={{
                    color: mode === "dark" ? "#fff" : "#111",
                    margin: 0,
                    fontWeight: 600,
                    fontSize: "22px",
                  }}
                >
                  {report.total}
                </h4>
              </div>

              {/* Right Side (Icon) */}
              <div
                style={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "50px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: mode === "dark" ? "#363F4F" : "#F1F1F1",
                }}
              >
                <i
                  className={`mdi mdi-${report.iconClass}`}
                  style={{
                    fontSize: "24px",
                    color:
                      report.badgecolor === "info"
                        ? "#2990DF"
                        : report.badgecolor === "info"
                          ? "#E53E3E"
                          : "#2990DF",
                  }}
                ></i>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  )
}

MiniCards.propTypes = {
  reports: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      iconClass: PropTypes.string,
      badgecolor: PropTypes.string,
    })
  ),
  mode: PropTypes.oneOf(["light", "dark"]),
  cardPadding: PropTypes.string,
  onCardClick: PropTypes.func,
}

export default MiniCards
